import spacing from '@rsa-digital/evo-shared-components/helpers/spacing';
import styled from 'styled-components';

export const AlertBannerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  margin: ${spacing(2)};
`;
